import {DeviceType} from '@gongxigames/framework/core/types';
import { Layer } from '@pixi/layers';
import {Installer} from '@gongxigames/framework/core/installer';

export type SystemComponentType = 'service' | 'module' | 'view';

export interface ISystemComponent {
    type: SystemComponentType;
    configure?(config: any): Promise<void> | void;
    init?(): Promise<void> | void;
    destroy?(): void;
}

export type ModuleInitPhase = 'initial' | 'default';
export type ModuleIsEnabledFilter = (components: Installer) => boolean | undefined;

export type ComponentConfig = {
    new (...args: any[]): any;
    NAME: symbol | string;
};

export type ComponentSingletonsConfig = {
    isEnabled?: ModuleIsEnabledFilter;
} & ComponentConfig;

export type ComponentInstanceWithConfig<I extends ISystemComponent = ISystemComponent, C extends ComponentConfig = ComponentConfig> = {instance: I; config: C;};

export type ComponentModuleConfigParameters = {
    initPhase?: ModuleInitPhase;
    platform?: DeviceType[] | DeviceType;
    isEnabled?: ModuleIsEnabledFilter;
};

export type ComponentModuleViewConfigParameters = {
    layer: Layer;
} & ComponentModuleConfigParameters;

export type ComponentServiceConfig = ComponentConfig;
export type ComponentModuleConfig = ComponentModuleConfigParameters & ComponentConfig;
export type ComponentModuleViewConfig = ComponentModuleViewConfigParameters & ComponentConfig;

export type ComponentsConfigs = {
    services?: ComponentServiceConfig[];
    modules?: ComponentModuleConfig[];
    views?: ComponentModuleViewConfig[];
    classes?: ComponentConfig[];
    singletons?: ComponentSingletonsConfig[];
    constants?: ComponentConfig[];
};
